const value = {
    confirmDeleteUnit: 'Are you sure you want to delete the unit?',
    deleteUnit: 'Delete unit',
    createUnitLabel: 'Create a units here with theory, quiz, and practice here',
    createUnit: 'Create a unit',
    withoutContext: 'Without Context',
    newUnit: 'New unit',
    noUnits: 'No units',
  };

export default value;
